import { useContext, useEffect } from "react";
import { History } from "history";
import {
  UNSAFE_NavigationContext,
  useLocation,
} from "react-router-dom";

export const UNSAVED_APP_SETTINGS_MESSAGE =
  "You have unsaved app settings. Leave without saving them?";

export const useUnsavedChangesGuard = (enabled: boolean) => {
  const { navigator } = useContext(UNSAFE_NavigationContext);
  const location = useLocation();

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const blockableNavigator = navigator as typeof navigator &
      Pick<History, "block">;
    const unblock = blockableNavigator.block((transition) => {
      const staysOnSettingsPage =
        transition.location.pathname === location.pathname;

      if (
        !staysOnSettingsPage &&
        !window.confirm(UNSAVED_APP_SETTINGS_MESSAGE)
      ) {
        return;
      }

      unblock();
      transition.retry();
    });

    return unblock;
  }, [enabled, location.key, location.pathname, navigator]);
};
